// Translation des textes JudgeMe pour les badges de reviews
(function() {
  var isProcessing = false;

  function translateJudgemeTexts() {
    if (isProcessing) return;
    isProcessing = true;

    document.querySelectorAll('.jdgm-star-rating, .jdgm-badge').forEach(function(el) {
      var html = el.innerHTML;
      if (html.indexOf('No reviews') !== -1 || html.match(/\d+\s+Reviews?/i)) {
        el.innerHTML = html
          .replace(/No reviews/gi, 'Aucun avis')
          .replace(/(\d+)\s+Reviews/gi, '$1 avis')
          .replace(/(\d+)\s+Review(?!s)/gi, '$1 avis');
      }
    });

    isProcessing = false;
  }

  // Exécuter après chargement et avec délais pour JudgeMe async
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateJudgemeTexts);
  } else {
    translateJudgemeTexts();
  }

  setTimeout(translateJudgemeTexts, 1000);
  setTimeout(translateJudgemeTexts, 2000);
  setTimeout(translateJudgemeTexts, 3000);
})();